import React, { useCallback, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import Text from '@/components/Text'
import { primary, errorText } from '@/constant'
import { CheckCircleFilled } from '@/icon'
import { LoginHeader, HeaderContent, FlexColumn } from './loginView'
import { LoadingButton } from '@/components/Button'
import Form, { FormItem } from '@/components/Form'
import { TextField, styled } from '@mui/material'
import { createOrg, setDefaultOrg } from '@/api'
import { CreateOrg } from '@/types'

export const ErrorText = styled('span')(() => ({
  color: errorText,
}))

export const Onboarding = () => {
  const [formValue, setFormValue] = useState<CreateOrg>({ name: '' })
  const [hasError, setHasError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [searchParams] = useSearchParams()
  const redirect = searchParams?.get('redirect')
  const redirectUrl = redirect ? decodeURIComponent(redirect) : '/console/workbench'

  const defaultOrg = useMutation(setDefaultOrg, {
    onSuccess: () => {
      location.href = redirectUrl
    },
    onError: (err: string) => {
      location.href = '/'
    },
  })

  const createOrgMutation = useMutation(createOrg, {
    onError: () => {
      setErrorMessage('创建空间失败')
      setLoading(false)
    },
    onSuccess: (data) => {
      defaultOrg.mutate({ ID: data.id })
    },
    onSettled: () => {
      setLoading(false)
    },
  })

  const handleCreatOrg = useCallback(() => {
    createOrgMutation.mutate(formValue)
  }, [createOrgMutation, formValue])

  const handelChangeForm = useCallback((value: CreateOrg) => {
    setFormValue(value)
  }, [])

  const handleChangeValidate = useCallback((valdateState: boolean) => {
    setHasError(valdateState)
  }, [])

  return (
    <FlexColumn>
      <LoginHeader>
        <Text size='md' sx={{ display: 'flex', alignItems: 'center' }}>
          <CheckCircleFilled sx={{ color: primary, fontSize: '32px', marginLeft: '-4px' }} />
          请创建一个空间
        </Text>
        <HeaderContent>
          <Text size='xs' weight='thin' sx={{ fontSize: '14px' }}>
            资源、权限、财务等统一管理
          </Text>
        </HeaderContent>
      </LoginHeader>
      <Form
        initialValue={formValue}
        // @ts-ignore
        onFormValueChange={handelChangeForm}
        // @ts-ignore
        onValidate={handleChangeValidate}
        validating={false}
      >
        <FormItem
          label='name'
          text='空间名称'
          rules={{
            errorMessage: '空间名称不能为空',
            validator: (value: string) => value?.length > 0,
          }}
        >
          <TextField placeholder='请输入空间名称' fullWidth={true} type='text' />
        </FormItem>
        <ErrorText>{errorMessage}</ErrorText>
      </Form>
      <LoadingButton
        loading={loading}
        disabled={createOrgMutation.isLoading || hasError}
        buttonStyle={{
          width: '100%',
          fontSize: '16px',
        }}
        onClick={handleCreatOrg}
      >
        创建空间
      </LoadingButton>
    </FlexColumn>
  )
}
